module.exports = __webpack_public_path__ + "static/media/Amanda M.68845b9a.jpg";